import React, { useEffect, useState } from "react";
import "./HomeNewsSection.css";
import { Link, useLocation } from "react-router-dom";
import { getLanguage } from 'react-switch-lang';

import en from '../en.json';
import ma from '../ma.json';
import { BASE_URL } from '../constant.js';

const translationData = { en: en, mr: ma };

const HomeNewsSection = () => {
  const location = useLocation();
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [language, setLanguage] = useState(() => getLanguage() || 'en');
  const t = (key) => {
    const langKey = language === 'ma' || language === 'mr' ? 'mr' : 'en';
    return translationData[langKey]?.[key] || '';
  };
  useEffect(() => {
    const checkLang = () => {
      const current = getLanguage() || 'en';
      setLanguage(prev => prev !== current ? current : prev);
    };
    checkLang();
    const interval = setInterval(checkLang, 500);
    window.addEventListener('storage', checkLang);
    return () => { clearInterval(interval); window.removeEventListener('storage', checkLang); };
  }, []);

  useEffect(() => {
    const apiLang = (language === 'ma' || language === 'mr') ? 'ma' : 'en';
    setLoading(true);

    const fetchLatestNews = async () => {
      const currentYear = new Date().getFullYear();
      let allNews = [];
      let year = currentYear;
      const minYear = 2018;

      while (allNews.length < 3 && year >= minYear) {
        try {
          const res = await fetch(
            `${BASE_URL}news/getNewsArticleFrontEnd/${apiLang}/1/0/0/${year}`
          );
          const data = await res.json();
          if (Array.isArray(data) && data.length > 0) {
            allNews = [...allNews, ...data];
          }
        } catch (error) {
          console.error(`Error fetching news for ${year}:`, error);
        }
        year--;
      }

      setNewsData(allNews.slice(0, 3));
      setLoading(false);
    };

    fetchLatestNews();
  }, [language]);

  // Scroll to top when navigating to /news/1 or /news-details/:id
  useEffect(() => {
    if (
      location.pathname === "/news/1" ||
      /^\/news-details\//.test(location.pathname)
    ) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location.pathname]);

  const stripHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  return (
    <section className="home-news-section">
      <div className="home-news-container">

        <span className="home-news-subheading">{t('news_subheading')}</span>

        <h2 className="home-news-heading">
          {t('news_title')}
        </h2>

        <p className="home-news-description">
          {t('news_desc')}
        </p>

        {loading ? (
          <p>Loading news...</p>
        ) : (
          <div className="home-news-grid">
            {newsData.map((item) => (
              <div className="home-news-card" key={item.news_article_id}>

                {/* Clickable Image */}
                <Link to={`/news-details/${item.news_article_id}`}>
                  <div className="home-news-image">
                    <img
                      src={item.image_name}
                      alt={item.title}
                      className="home-news-img"
                    />
                  </div>
                </Link>

                <div className="home-news-content">
                  <div className="home-news-date">
                    <i className="fas fa-calendar-alt"></i>
                    <span>{item.date}</span>
                  </div>

                  {/* Clickable Title */}
                  <p className="home-news-title">
                    <Link to={`/news-details/${item.news_article_id}`}>
                      {item.title}
                    </Link>
                  </p>

                  <p className="home-news-text">
                    {stripHtml(item.short_description || item.description)
                      .slice(0, 120)}...
                  </p>
                </div>

              </div>
            ))}
          </div>
        )}

        <Link to="/news/1" className="btn home-news-button">
          {t('news_view_all')} <i className="fas fa-chevron-right"></i>
        </Link>

      </div>
    </section>
  );
};

export default HomeNewsSection;